/**
 * Relay for Profile
 */

import { graphql as gql } from 'react-relay';
const graphql = gql;

export const AccountPageQuery = graphql`
  query profile_Query {
    viewer {
      id
      ...profile_viewer
    }
  }
`;

export const Profile = graphql`
  fragment profile on Profile {
    id
    user_id
    email
    external_provider
    first_name
    is_new_user
    ga_account_goal_sent
    last_name
    picture
    company_name
    company_size{
      name
    }
    industry{
      name
    }
    job_type{
      name
    }
  }
`;

export const ProfileFragment = graphql`
  fragment profile_viewer on Viewer {
    id
    profile {
      ...profile @relay(mask: false)
    }
  }
`;

export const UpdateProfileMutation = graphql`
  mutation profile_Mutation (
    $profileInput: UpdateProfileInput!
  ) {
  updateProfile(input: $profileInput) {
    profile {
      ...profile @relay(mask: false)
    }
  }
}
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/relay/profile.ts